import AuthContext from "../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

import { addEntity, getEntityTypes } from "../helpers/tableauUserHelpers";

import '../content/ccbh.ui.css';
import './addEntityModal.css';
import '../content/ccbh-tableau-portal_2.0.css';

import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import '../content/ccbh.ui.css';
import { add } from "date-fns";

const AddEntityModal = ({closeModal, selectedEntity = null}) => {
    let navigate = useNavigate();
    const { logout } = useContext(AuthContext);

    const [entityId, setEntityId] = useState(selectedEntity?.id);
    const [entityTypeId, setEntityTypeId] = useState(selectedEntity?.type);
    const [entityName, setEntityName] = useState(selectedEntity?.name);
    const [addEntityButtonDisabled, setAddEntityButtonDisabled] = useState('disabled');
    const [entityTypes, setEntityTypes] = useState('');
    
    const editEntityIdEnabled = () => {
        if(selectedEntity === null){
            return '';
        }
        return 'disabled';
    };
    
    const [entityIdDisabled, setEntityIdDisabled] = useState(() => editEntityIdEnabled());

    const fetchEntity = async() => {
        const response = await addEntity(entityId, entityTypeId, entityName);
        console.log(response);
    };

    const addNewEntity = () => {
        fetchEntity();
        closeModal();
    };

    const toggleAddEntityButton = (id, name, type) => {
        if(id === '' || name === '' || type === ''){
            setAddEntityButtonDisabled('disabled');
        }else{
            setAddEntityButtonDisabled('');
        }
    };

    const handleEnityNameChange = event => {
        if(event.target.value.length > 20){
            ccbhmessagebox({
                message: "Entity Name must be less than 200 characters, Please correct this. Current Lenght is: " + event.target.value.length,
                title: "Entity Name length error",
                closebutton: false,
                modal: true,
                buttons: {
                    'Ok': function() {
                        removeMsg();
                    }
                }
            });
        }else{
            setEntityName(event.target.value);
            toggleAddEntityButton(entityId, event.target.value, entityTypeId);
        }
    };

    const handleEntityIdChange = event =>{
        setEntityId(event.target.value);
        toggleAddEntityButton(event.target.value, entityName, entityTypeId);
    };

    const handleEntityTypeChange = event => {
        if(selectedEntity === null){
            setEntityTypeId(event.target.value);
            toggleAddEntityButton(entityId, entityName, event.target.value, entityName);
        }else{
            ccbhmessagebox({
                message: "Changing the Entity Type will change the type for all employees associated with this entity. This will result in the employees losing access to all dashboards associated with that entity type. If you are sure about this change select OK",
                title: "Entity Type Change Warning",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok' : function () {
                        setEntityTypeId(event.target.value);
                        toggleAddEntityButton(entityId, entityName, event.target.value, entityName);
                        removeMsg();
                    },
                    'Cancel': function () {
                        removeMsg();
                    }
                }
            });
        }
    };

    const fetchEntityTypes = async() => {
        return await getEntityTypes();
    };

    const entityTypeList = (value, name) =>{
        let selected='';
        if(selectedEntity !== null && selectedEntity.type === value){
            selected = 'selected';
        }
        return (
            <option value={value} selected={selected}>{name}</option>
        );
    };

    useEffect(()=>{
        fetchEntityTypes().then((et) =>{
            setEntityTypes(et);
            setEntityTypes(et.map((e) => entityTypeList(e.id, e.name)));
        })
        
        console.log('Show EntityModal');
    }, []);

    return(
        <>
            <div className="modal-container-addEntity">
                <div className="modal-addEntity">
                    <div>
                        <input type="text" className="settings-text-input" id="entity-name" onKeyUp={handleEnityNameChange} defaultValue={entityName} />
                        <label className="settings-label">Entity Name</label>
                        <br />

                        <input type="text" className="settings-text-input" id="entity-id" onKeyUp={handleEntityIdChange} defaultValue={entityId}  disabled={entityIdDisabled}  />
                        <label className="settings-label">Entity ID</label>
                        <br />

                        <select id="entity-type" onChange={handleEntityTypeChange} >
                            <option value="">-- SELECT ONE--</option>
                            {entityTypes}
                        </select>
                        <label className="settings-label">Entity Type</label>
                    </div>

                    <div id="settings-button-row">
                        <input type="button" id="add-entity-modal" value="Save" onClick={addNewEntity} disabled={addEntityButtonDisabled} />
                        <input type="button" id="close-modal" value="Cancel" onClick={closeModal} />
                    </div>
                </div>
            </div> 
        </>
    );
}

export default AddEntityModal;